import React from 'react';
import { Typography, Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { copyToClipboard } from '../utils';

const PromptsSection = ({ prompts }) => {
  if (!prompts || Object.keys(prompts).length === 0) return null;

  return (
    <div className="jdv-section jdv-prompts-section">
      <div className="jdv-section-header">
        <Typography.Title level={5} className="jdv-section-title">
          💬 Prompts & Text Inputs
        </Typography.Title>
        <span className="jdv-count-badge">{Object.keys(prompts).length}</span>
      </div>

      <div className="jdv-prompts-list">
        {Object.entries(prompts).map(([key, prompt]) => {
          const isNegative = key.toLowerCase().includes('negative');
          
          return (
            <div 
              key={key} 
              className={`jdv-prompt-card ${isNegative ? 'jdv-prompt-negative' : ''}`}
            >
              <div className="jdv-prompt-header">
                <div className="jdv-prompt-label">
                  <span className={`jdv-prompt-type ${isNegative ? 'negative' : 'positive'}`}>
                    {isNegative ? '🚫' : '✨'}
                  </span>
                  <Typography.Text strong>
                    {prompt.label}
                  </Typography.Text>
                </div>
                <Button
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={() => copyToClipboard(prompt.content)}
                >
                  Copy
                </Button>
              </div>
              
              <div className="jdv-prompt-content">
                <Typography.Paragraph
                  ellipsis={{ rows: 4, expandable: true, symbol: 'more' }}
                  className="jdv-prompt-text"
                >
                  {prompt.content}
                </Typography.Paragraph>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PromptsSection;
